import Modal from '../components/Modal';
import ItemList from '../utils/ItemList';
import Button from '../components/Button';
import Switch from '../components/Switch';
import Stream from '../utils/Stream';

export default class RouteToBindRoleModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = false;
  }

  className() {
    return 'Modal--small NickameModal FlarumBadgesConfirmModal';
  }

  title() {
    return '';
  }

  content() {
    return [
      <div className="Modal-body">
        <p>{this.attrs.text}</p>
        <div className="Form-group">
          {Button.component(
            {
              className: 'Button Button--primary',
              loading: this.loading,
              onclick: () => this.confirm(),
            },
            app.translator.trans('dl-response.forum.RouteToBindRoleModal.confirm.yes')
          )}
          {Button.component(
            {
              className: 'Button Button--close',
              disabled: this.loading,
              onclick: () => this.hide(),
            },
            app.translator.trans('dl-response.forum.RouteToBindRoleModal.confirm.no')
          )}
        </div>
      </div>,

      // <div className="Modal-footer FlarumBadgesConfirmButtons">

      // </div>,
    ];
  }

  /**
   * Confirm
   */
  confirm() {
    // Act as promise
    if (this.attrs.promise) {
      this.loading = true;

      this.attrs.onconfirm(
        () => this.hide(),
        () => {
          this.loading = false;
          m.redraw();
        }
      );
      return;
    }

    this.attrs.onconfirm();
    this.hide();
  }
}
